import {
    Pin as IconAmount,
    Event as IconDateTime,
    ArrowDropDownCircle as IconDropdown,
    UploadFile as IconRecording,
    RadioButtonChecked as IconSelect,
    Subject as IconText,
} from "@mui/icons-material";

export const questionTypeOptions = [
    {
        id: "GqlSettingsFormTemplateQuestionTypeText",
        translationKey: "formTemplateQuestionForm.typeText",
        icon: <IconText />,
    },
    {
        id: "GqlSettingsFormTemplateQuestionTypeAmount",
        translationKey: "formTemplateQuestionForm.typeAmount",
        icon: <IconAmount fontSize="small" />,
    },
    {
        id: "GqlSettingsFormTemplateQuestionTypeRecording",
        translationKey: "formTemplateQuestionForm.typeRecording",
        icon: <IconRecording fontSize="small" />,
    },
    {
        id: "GqlSettingsFormTemplateQuestionTypeSelect",
        translationKey: "formTemplateQuestionForm.typeSelect",
        icon: <IconSelect fontSize="small" />,
    },
    {
        id: "GqlSettingsFormTemplateQuestionTypeDropdown",
        translationKey: "formTemplateQuestionForm.typeDropdown",
        icon: <IconDropdown fontSize="small" />,
    },
    {
        id: "GqlSettingsFormTemplateQuestionTypeDateTime",
        translationKey: "formTemplateQuestionForm.typeDateTime",
        icon: <IconDateTime fontSize="small" />,
    },
];
